import type { HelpFile } from '../../types/help'
import { PatternSuggestDialogTestIds } from '../../../testids/PatternSuggestDialogTestIds'

export const patternSuggestDialogHelp: HelpFile = {
  docPage: '/docs/schema/attribute-definitions',
  texts: {
    [PatternSuggestDialogTestIds.patternAddSample]: null,
    [PatternSuggestDialogTestIds.patternColActions]: null,
    [PatternSuggestDialogTestIds.patternColIndex]: null,
    [PatternSuggestDialogTestIds.patternColValue]: null,
    [PatternSuggestDialogTestIds.patternEmptyState]: 'Add sample values to let the system infer a validation regex pattern.',
    [PatternSuggestDialogTestIds.patternInferred]: 'Regex pattern inferred from the current samples — review before applying.',
    [PatternSuggestDialogTestIds.patternSampleInput]: 'Enter a sample value to include in the pattern inference.',
    [PatternSuggestDialogTestIds.patternSamplesBody]: null,
    [PatternSuggestDialogTestIds.patternSuggestAccept]: 'Apply the inferred pattern to the attribute definition.',
    [PatternSuggestDialogTestIds.patternSuggestCancel]: null,
    [PatternSuggestDialogTestIds.patternSuggestClear]: 'Remove all samples and reset the inferred pattern.',
    [PatternSuggestDialogTestIds.patternSuggestTitle]: 'Infer a validation regex from sample values.',
  },
}
